import { render, staticRenderFns } from "./SubMasken.vue?vue&type=template&id=2371cf56&scoped=true"
import script from "./SubMasken.vue?vue&type=script&lang=ts"
export * from "./SubMasken.vue?vue&type=script&lang=ts"
import style0 from "./SubMasken.vue?vue&type=style&index=0&id=2371cf56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371cf56",
  null
  
)

export default component.exports